// extracted by mini-css-extract-plugin
export var bacgroundImage = "NavComponent-module--bacgroundImage--a6a7e";
export var categoryColumn = "NavComponent-module--categoryColumn--b7267";
export var categoryLinks = "NavComponent-module--categoryLinks--edd43";
export var categoryTitle = "NavComponent-module--categoryTitle--d7ccc";
export var changedLink = "NavComponent-module--changedLink--49bc5";
export var headerCategoriesData = "NavComponent-module--headerCategoriesData--b0373";
export var headerCategoriesDataOpen = "NavComponent-module--headerCategoriesDataOpen--2167c";
export var links = "NavComponent-module--links--67f22";
export var navContainer = "NavComponent-module--navContainer--abfab";
export var normalLink = "NavComponent-module--normalLink--1de7e";
export var renderedItems = "NavComponent-module--renderedItems--776cc";
export var renderedItemsOpen = "NavComponent-module--renderedItemsOpen--962f8";
export var subCategoriesContainer = "NavComponent-module--subCategoriesContainer--3bc8b";
export var subCategoryColumn = "NavComponent-module--subCategoryColumn--7064f";
export var treatmentList = "NavComponent-module--treatmentList--9b124";